import { ReactNode } from 'react';

import { Box, HStack, Header, Pressable, Text, VStack } from '@rbilabs/universal-components';
import { GestureResponderEvent } from 'react-native';

type IOfferGroupItem = {
  name: string;
  groupId: string;
  description?: string;
  image: ReactNode;
  onPress?: ((event?: GestureResponderEvent) => any) | null | undefined;
};

export const OfferGroupItem = ({
  name,
  description,
  groupId,
  image,
  onPress,
  ...buttonProps
}: IOfferGroupItem) => (
  <Pressable
    accessibilityRole="button"
    dd-action-name={name}
    onPress={onPress}
    mb="$2.5"
    width="full"
    {...buttonProps}
  >
    {({ isHovered, isPressed, isFocused }) => {
      const pressed = isPressed && onPress;
      return (
        <Box bg="token.background-pattern" rounded={10} borderWidth={0} borderColor={'transparent'}>
          <VStack
            p={['$3', '$4']}
            pt={'$3'}
            borderTopRadius={10}
            borderBottomRadius={10}
            bg={pressed || isFocused ? 'token.background-focus' : 'transparent'}
          >
            <HStack mr="$2">
              {image}
              <VStack flexShrink={1} ml="$3" alignItems="flex-start" justifyContent="center">
                <Header
                  variant="headerThree"
                  color={isHovered ? 'token.text-active' : 'token.text-default'}
                  ellipsizeMode="tail"
                  numberOfLines={2}
                >
                  {name}
                </Header>
                {description ? (
                  <Text fontSize={12} lineHeight={16} numberOfLines={2} ellipsizeMode="tail">
                    {description}
                  </Text>
                ) : null}
              </VStack>
            </HStack>
          </VStack>
        </Box>
      );
    }}
  </Pressable>
);
